import { useEffect, useState } from "react";
import SupportTable from "../components/admin/support/SupportTable";
import ViewHeader from "../components/UiComponents/ViewHeader";
import SearchField from "../components/UiComponents/SearchField";
import { SearchContainer, SupportTableViewContainer } from "../components/admin/support/SupportStyles";
import CountrySelector from "../components/admin/impersonate/CountrySelector";
import { getCustomerErrors } from "../scripts/support";
import CitySelector from "../components/admin/impersonate/CitySelector";
import styled from "styled-components";
import { getCity, normalize, getCountry } from "../components/admin/impersonate/filteringUtils";
import VenueTypeSelector from "../components/admin/impersonate/VenueTypeSelector";
import { venueItems } from "../components/settings/venue/venueTypeDropdown/venueTypeDropdown";

const AdaptedSearchContainer = styled(SearchContainer)`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 12px;
`;

const DEFAULT_EXCLUDED_LABELS = ["Demo Venue"]; // labels


const CustomerErrorsView = props => {
    const [customerData, setCustomerData] = useState();
    const [filteredCustomerData, setFilteredCustomerData] = useState();
    const [searchValue, setSearchValue] = useState('');
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [selectedCity, setSelectedCity] = useState(null);
    const [selectedTypes, setSelectedTypes] = useState(venueItems.filter(v => !DEFAULT_EXCLUDED_LABELS.includes(v.label)).map(v => v.label));

    const updateSelectedTypes = (updateSelectedTypes) => {
        setSelectedTypes(updateSelectedTypes);
    }

    useEffect(() => {
        getData();
    }, []);

    useEffect(() => {
        if (!Array.isArray(customerData)) {
            setFilteredCustomerData([]);
            return;
        }

        const nSearch = normalize(searchValue);

        setFilteredCustomerData(
            customerData.filter((customer) => {
            const country = getCountry(customer);
            const city = getCity(customer);

            let venueType = customer?.type;
            // Treat null/undefined/empty-string/"null" as "Other"
            if (
                venueType == null ||
                (typeof venueType === "string" && venueType.trim() === "") ||
                venueType === "null"
            ) {
                venueType = "Other";
            }

            const matchesCountry =
                selectedCountry == null ||
                normalize(country) === normalize(selectedCountry.key);

            const matchesCity =
                selectedCity == null ||
                normalize(city) === normalize(selectedCity.key ?? selectedCity);

            const selectedTypeSet = new Set(selectedTypes ?? []);
            const matchesTypes =
                selectedTypeSet.size === 0
                    ? true
                    : selectedTypeSet.has(venueType);

            const matchesSearch =
                !nSearch ||
                normalize(customer?.customerId)?.includes(nSearch) ||
                normalize(customer?.companyName)?.includes(nSearch) ||
                normalize(city)?.includes(nSearch) ||           // allow searching by city text
                normalize(country)?.includes(nSearch) ||
                normalize(venueType)?.includes(nSearch);

            return matchesCountry && matchesCity && matchesTypes && matchesSearch;
            })
        );
        }, [customerData, searchValue, selectedCountry, selectedCity, selectedTypes, setFilteredCustomerData]);

    const getData = async () => {
        var data = await getCustomerErrors();
        setCustomerData(data?.customerSummaries);
        setFilteredCustomerData(data?.customerSummaries);
    }

    return <>
        <ViewHeader headerText={'Customer Errors'} backLink={'/supportcenter'} />

        <SupportTableViewContainer>
            <AdaptedSearchContainer>
                <SearchField placeholder={'Search customer ID or name'} value={searchValue} onChange={(e) => setSearchValue(e.target.value)} />
                <CountrySelector selectedCountry={selectedCountry} customers={customerData} onSelect={(country) => setSelectedCountry(country)} />
                <CitySelector selectedCity={selectedCity} customers={customerData} onSelect={(city) => setSelectedCity(city)} />
                <VenueTypeSelector selectedTypes={selectedTypes} customers={customerData} onChange={updateSelectedTypes} />
            </AdaptedSearchContainer>

            <SupportTable customerErrors={filteredCustomerData} setCustomer={props.setCustomer} />
        </SupportTableViewContainer>

    </>
}

export default CustomerErrorsView;